 (function () {  
    async function insertSectionCartDrawer() {
      if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return

      var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
      if (!cartDrawerItems) return

      if (cartDrawerItems.classList.contains('is-empty')) return

      var wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML)
 
      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartDrawer()

  /*  async function insertSectionCartPage() {
      const cartItems = document.querySelector('cart-items')
      if (!cartItems) return

      const existingUpsells = document.querySelector('#MainContent #cart-drawer-upsell')
      if (existingUpsells) {
        existingUpsells.remove()
      }

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartPage() */
    
    window.onChangeKsUpsellVariantSelector = function( select, event) {
      event.preventDefault()
      const imgSrc = select.options[select.selectedIndex].dataset.variantImg

      if (imgSrc) {
        const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img')
        img.src = imgSrc
      }
    }

    function listenCartDrawer() {
      const element = document.querySelector('cart-drawer')
      if (!element) return
  
      let timer 
       
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))
 
            insertSectionCartDrawer()
        }, 250)
      })

      observer.observe(element, {  
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartDrawer()

    function listenCartPage() {
      const element = document.querySelector('#MainContent .cart__items')
      if (!element) return

      let timer
      
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))

            insertSectionCartPage()
        }, 250)
      })

      observer.observe(element, { 
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartPage()
  })();

/* NAV_PREMIUM_MENU_729 */
(function(){
  var css="/* Premium mobile nav sheet \u2014 not full-screen takeover */\n.mobile-drawer{\n  position:fixed !important;\n  inset:0 !important;\n  z-index:2147483000 !important;\n  display:flex !important;\n  justify-content:flex-end;\n  align-items:stretch;\n  padding:14px !important;\n  box-sizing:border-box;\n  background:rgba(18,16,12,0.42) !important;\n  -webkit-backdrop-filter:blur(8px);\n  backdrop-filter:blur(8px);\n  transform:none !important;\n  opacity:0;\n  visibility:hidden;\n  pointer-events:none !important;\n  overflow:hidden !important;\n  transition:opacity .28s ease, visibility .28s ease;\n}\n.mobile-drawer[hidden]{\n  display:flex !important;\n  opacity:0 !important;\n  visibility:hidden !important;\n  pointer-events:none !important;\n  transform:none !important;\n}\n.mobile-drawer.open{\n  opacity:1 !important;\n  visibility:visible !important;\n  pointer-events:auto !important;\n  transform:none !important;\n}\n.mobile-drawer .md-sheet{\n  width:min(400px, 86vw);\n  max-width:100%;\n  height:100%;\n  max-height:100%;\n  margin:0;\n  background:var(--ivory,#FAF7F0);\n  color:var(--ink,#211D18);\n  border-radius:18px;\n  box-shadow:\n    0 24px 80px -20px rgba(15,12,8,0.55),\n    0 0 0 1px rgba(33,29,24,0.06);\n  transform:translate3d(110%,0,0);\n  transition:transform .38s cubic-bezier(.22,1,.36,1);\n  overflow-x:hidden;\n  overflow-y:auto;\n  -webkit-overflow-scrolling:touch;\n  padding:22px 20px 48px;\n  box-sizing:border-box;\n  pointer-events:auto;\n}\n.mobile-drawer.open .md-sheet{\n  transform:translate3d(0,0,0);\n}\n.mobile-drawer .md-head{\n  display:flex;\n  justify-content:space-between;\n  align-items:center;\n  margin-bottom:22px;\n  padding-bottom:16px;\n  border-bottom:1px solid rgba(33,29,24,0.08);\n}\n.mobile-drawer .md-close{\n  width:40px;\n  height:40px;\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  border:1px solid rgba(33,29,24,0.14);\n  border-radius:50%;\n  background:rgba(255,255,255,0.7);\n  cursor:pointer;\n  font-size:16px;\n  line-height:1;\n  color:var(--ink,#211D18);\n  transition:background .2s ease, border-color .2s ease;\n}\n.mobile-drawer .md-close:hover{\n  background:#fff;\n  border-color:rgba(33,29,24,0.28);\n}\n.mobile-drawer .md-nav{\n  display:flex;\n  flex-direction:column;\n}\n.mobile-drawer .md-item{\n  border-bottom:1px solid rgba(33,29,24,0.08);\n}\n.mobile-drawer .md-item summary{\n  list-style:none;\n  padding:16px 2px;\n  display:flex;\n  justify-content:space-between;\n  align-items:center;\n  font-size:15px;\n  font-weight:500;\n  cursor:pointer;\n  gap:12px;\n}\n.mobile-drawer .md-item summary::-webkit-details-marker{display:none;}\n.mobile-drawer .md-item summary::after{\n  content:'+';\n  font-weight:400;\n  color:var(--ink-soft,#5C5548);\n  flex-shrink:0;\n}\n.mobile-drawer .md-item[open] summary::after{content:'\u2013';}\n.mobile-drawer .md-item ul{\n  padding:0 2px 14px;\n  margin:0;\n  list-style:none;\n}\n.mobile-drawer .md-item ul li{padding:7px 0;font-size:14px;}\n.mobile-drawer .md-item ul li a{color:var(--ink-soft,#5C5548);}\n.mobile-drawer .md-shop-all{color:var(--gold-deep,#B98A4E)!important;font-weight:600;}\n.mobile-drawer .md-link{\n  display:block;\n  padding:16px 2px;\n  border-bottom:1px solid rgba(33,29,24,0.08);\n  font-size:15px;\n  font-weight:500;\n  color:var(--ink,#211D18);\n  text-decoration:none;\n}\n.mobile-drawer .md-link--accent{color:var(--gold-deep,#B98A4E);}\n\n@media(min-width:1281px){\n  .mobile-drawer{display:none !important;}\n}\n@media(max-width:560px){\n  .mobile-drawer{padding:10px !important;}\n  .mobile-drawer .md-sheet{\n    width:min(100%, 92vw);\n    border-radius:16px;\n    padding:18px 16px 40px;\n  }\n}\n";
  function paint(){
    if (!document.getElementById('oxiram-nav-sheet-style')) {
      var s=document.createElement('style');
      s.id='oxiram-nav-sheet-style';
      s.textContent=css;
      (document.head||document.documentElement).appendChild(s);
    }
    var drawer=document.querySelector('[data-oxiram-drawer]');
    if (!drawer) return;
    if (!drawer.querySelector('.md-sheet')) {
      var sheet=document.createElement('div');
      sheet.className='md-sheet';
      while (drawer.firstChild) sheet.appendChild(drawer.firstChild);
      drawer.appendChild(sheet);
    }
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', paint);
  else paint();
  document.addEventListener('shopify:section:load', paint);
})();

/* JOURNAL_RESP_FIX_731 */
(function () {
  if (typeof document === 'undefined') return;
  var css = `
@media (max-width: 1160px){
  .oxiram-journal .featured-post{
    grid-template-columns:1fr !important;
  }
  .oxiram-journal .featured-post > *{
    min-width:0 !important;
  }
  .oxiram-journal .featured-media{
    aspect-ratio:16/10 !important;
    min-height:0 !important;
  }
  .oxiram-journal .featured-copy{
    padding:30px 24px !important;
    min-width:0 !important;
  }
}
@media (max-width: 900px){
  .oxiram-journal .featured-copy{
    padding:24px 18px !important;
  }
}
`;
  function apply() {
    var id = 'oxiram-journal-resp-fix-731';
    if (document.getElementById(id)) return;
    var s = document.createElement('style');
    s.id = id;
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  document.addEventListener('shopify:section:load', apply);
})();

/* SITE_RESP_HARDFIX_746 */
(function () {
  if (typeof document === 'undefined') return;
  var css = ''
    + '@media (max-width:1024px){'
    + 'html,body{overflow-x:hidden !important;}'
    + '#MainContent,.main-content,.content-for-layout,.shopify-section,.oxiram-lux,.oxiram-lux .section,.oxiram-lux .wrap{width:100% !important;max-width:100% !important;min-width:0 !important;box-sizing:border-box !important;}'
    + '.oxiram-lux .wrap{padding-left:14px !important;padding-right:14px !important;margin-left:auto !important;margin-right:auto !important;}'
    + '.oxiram-lux .section{padding-top:56px !important;padding-bottom:56px !important;}'
    + '.oxiram-about .about-hero-content{padding-left:16px !important;padding-right:16px !important;padding-bottom:42px !important;max-width:100% !important;}'
    + '.oxiram-about .about-hero-content h1{max-width:16ch !important;}'
    + '.oxiram-about .about-hero-content p{max-width:100% !important;}'
    + '.oxiram-about .story-split,.oxiram-about .founder-inner,.oxiram-about .resp-row,.oxiram-about .values-grid,.oxiram-about .stats-strip,.oxiram-about .material-grid{grid-template-columns:1fr !important;gap:14px !important;}'
    + '.oxiram-article .article-shell{max-width:100% !important;padding-left:14px !important;padding-right:14px !important;}'
    + '.oxiram-article .article-body{max-width:100% !important;font-size:16px !important;line-height:1.75 !important;}'
    + '.oxiram-contact .contact-grid,.oxiram-contact .form-row,.oxiram-bundles .bundles-grid{grid-template-columns:1fr !important;}'
    + '}'
    + '@media (max-width:768px){'
    + '.oxiram-lux .wrap{padding-left:12px !important;padding-right:12px !important;}'
    + '.oxiram-about .about-cta .hero-ctas{flex-direction:column !important;align-items:stretch !important;max-width:360px !important;width:100% !important;margin-left:auto !important;margin-right:auto !important;}'
    + '.oxiram-about .about-cta .hero-ctas .btn{width:100% !important;}'
    + '}';
  function apply() {
    var id = 'oxiram-site-resp-hardfix-746';
    if (document.getElementById(id)) return;
    var s = document.createElement('style');
    s.id = id;
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  document.addEventListener('shopify:section:load', apply);
})();

/* ABOUT_CTA_DESKTOP_ROW_745 */
(function () {
  if (typeof document === 'undefined') return;
  var css = ''
    + '@media (min-width: 901px){'
    + '.oxiram-about .wrap.about-cta .hero-ctas{display:grid !important;grid-template-columns:repeat(2,minmax(220px,260px)) !important;justify-content:center !important;align-items:center !important;gap:14px !important;width:100% !important;max-width:620px !important;margin-left:auto !important;margin-right:auto !important;}'
    + '.oxiram-about .wrap.about-cta .hero-ctas .btn{width:100% !important;min-width:0 !important;margin:0 !important;justify-content:center !important;text-align:center !important;}'
    + '}';
  function apply() {
    var id = 'oxiram-about-cta-desktop-row-745';
    if (document.getElementById(id)) return;
    var s = document.createElement('style');
    s.id = id;
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  document.addEventListener('shopify:section:load', apply);
})();

/* HERO_SLIDER_RESP_810 — fit screen, never crop */
(function () {
  if (typeof document === 'undefined') return;
  var css = ''
    + '.hero-slide video,.hero-slide .hero-video,.hero-slide img.fallback{width:100% !important;height:100% !important;object-fit:contain !important;object-position:center center !important;background:#1F2B23 !important;transform:none !important;}'
    + '@media(max-width:1024px){'
    + '.hero{overflow:hidden !important;max-width:100vw !important;}'
    + '.hero-slides,.hero-slide{width:100% !important;max-width:100% !important;}'
    + '.hero-content{max-width:100% !important;box-sizing:border-box !important;}'
    + '.hero-dots{max-width:calc(100vw - 120px) !important;overflow-x:auto !important;flex-wrap:nowrap !important;scrollbar-width:none;}'
    + '.hero-dots::-webkit-scrollbar{display:none;}'
    + '}'
    + '@media(max-width:768px){'
    + '.hero{height:calc(100dvh - var(--oxiram-header-offset,72px)) !important;min-height:0 !important;max-height:none !important;}'
    + '.hero-slides{position:absolute !important;inset:0 !important;height:100% !important;}'
    + '.hero-slide{position:absolute !important;inset:0 !important;height:100% !important;min-height:0 !important;}'
    + '.hero-content{padding:0 16px 118px !important;}'
    + '.hero-content h1{font-size:clamp(30px,8.4vw,40px) !important;max-width:14ch !important;}'
    + '.hero-ctas{flex-direction:column !important;align-items:stretch !important;gap:10px !important;width:100% !important;max-width:320px !important;}'
    + '.hero-ctas .btn{width:100% !important;justify-content:center !important;box-sizing:border-box !important;min-height:48px !important;}'
    + '.hero-nav{right:12px !important;bottom:16px !important;}'
    + '.hero-dots{left:16px !important;right:100px !important;bottom:20px !important;}'
    + '}';
  function apply() {
    var id = 'oxiram-hero-slider-resp-810';
    var old = document.getElementById('oxiram-hero-slider-resp-741');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    if (document.getElementById(id)) return;
    var s = document.createElement('style');
    s.id = id;
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  document.addEventListener('shopify:section:load', apply);
})();

/* JOURNAL_TEXT_OVERFLOW_FIX_737 */
(function () {
  if (typeof document === 'undefined') return;
  var css = ''
    + '@media (max-width: 1280px){'
    + '.oxiram-journal .featured-post{display:flex !important;flex-direction:column !important;grid-template-columns:1fr !important;}'
    + '.oxiram-journal .featured-post > *{min-width:0 !important;width:100% !important;max-width:100% !important;}'
    + '.oxiram-journal .featured-media{aspect-ratio:16/10 !important;min-height:0 !important;}'
    + '.oxiram-journal .featured-copy{padding:28px 20px !important;min-width:0 !important;max-width:100% !important;overflow-wrap:anywhere !important;word-break:break-word !important;}'
    + '.oxiram-journal .featured-copy h2{font-size:clamp(28px,4.8vw,40px) !important;line-height:1.15 !important;}'
    + '.oxiram-journal .featured-copy p{max-width:100% !important;}'
    + '}';
  function apply() {
    var id = 'oxiram-journal-overflow-fix-737';
    if (document.getElementById(id)) return;
    var s = document.createElement('style');
    s.id = id;
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  document.addEventListener('shopify:section:load', apply);
})();

/* JOURNAL_RESP_HARDFIX_733 */
(function () {
  if (typeof document === 'undefined') return;
  var css = `
@media (max-width: 1400px){
  .oxiram-journal .featured-post{
    display:block !important;
    grid-template-columns:1fr !important;
  }
  .oxiram-journal .featured-media{
    display:block !important;
    width:100% !important;
    min-height:0 !important;
    aspect-ratio:16/10 !important;
  }
  .oxiram-journal .featured-copy{
    display:block !important;
    width:100% !important;
    max-width:100% !important;
    min-width:0 !important;
    box-sizing:border-box !important;
    padding:24px 18px !important;
    overflow-wrap:anywhere !important;
  }
  .oxiram-journal .featured-copy h2,
  .oxiram-journal .featured-copy p{
    max-width:100% !important;
    overflow-wrap:anywhere !important;
    word-break:break-word !important;
  }
}
`;
  function apply() {
    var id = 'oxiram-journal-hardfix-733';
    if (document.getElementById(id)) return;
    var s = document.createElement('style');
    s.id = id;
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  document.addEventListener('shopify:section:load', apply);
})();


/* NAV_PREMIUM_COMPAT_730 */
(function(){
  if (typeof document==='undefined') return;
  var css="/* Premium mobile nav sheet — not full-screen takeover */\n.mobile-drawer{\n  position:fixed !important;\n  inset:0 !important;\n  z-index:2147483000 !important;\n  display:flex !important;\n  justify-content:flex-end;\n  align-items:stretch;\n  padding:14px !important;\n  box-sizing:border-box;\n  background:rgba(18,16,12,0.42) !important;\n  -webkit-backdrop-filter:blur(8px);\n  backdrop-filter:blur(8px);\n  transform:none !important;\n  opacity:0;\n  visibility:hidden;\n  pointer-events:none !important;\n  overflow:hidden !important;\n  transition:opacity .28s ease, visibility .28s ease;\n}\n.mobile-drawer[hidden]{\n  display:flex !important;\n  opacity:0 !important;\n  visibility:hidden !important;\n  pointer-events:none !important;\n  transform:none !important;\n}\n.mobile-drawer.open{\n  opacity:1 !important;\n  visibility:visible !important;\n  pointer-events:auto !important;\n  transform:none !important;\n}\n.mobile-drawer .md-sheet{\n  width:min(400px, 86vw);\n  max-width:100%;\n  height:100%;\n  max-height:100%;\n  margin:0;\n  background:var(--ivory,#FAF7F0);\n  color:var(--ink,#211D18);\n  border-radius:18px;\n  box-shadow:\n    0 24px 80px -20px rgba(15,12,8,0.55),\n    0 0 0 1px rgba(33,29,24,0.06);\n  transform:translate3d(110%,0,0);\n  transition:transform .38s cubic-bezier(.22,1,.36,1);\n  overflow-x:hidden;\n  overflow-y:auto;\n  -webkit-overflow-scrolling:touch;\n  padding:22px 20px 48px;\n  box-sizing:border-box;\n  pointer-events:auto;\n}\n.mobile-drawer.open .md-sheet{\n  transform:translate3d(0,0,0);\n}\n.mobile-drawer .md-head{\n  display:flex;\n  justify-content:space-between;\n  align-items:center;\n  margin-bottom:22px;\n  padding-bottom:16px;\n  border-bottom:1px solid rgba(33,29,24,0.08);\n}\n.mobile-drawer .md-close{\n  width:40px;\n  height:40px;\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  border:1px solid rgba(33,29,24,0.14);\n  border-radius:50%;\n  background:rgba(255,255,255,0.7);\n  cursor:pointer;\n  font-size:16px;\n  line-height:1;\n  color:var(--ink,#211D18);\n  transition:background .2s ease, border-color .2s ease;\n}\n.mobile-drawer .md-close:hover{\n  background:#fff;\n  border-color:rgba(33,29,24,0.28);\n}\n.mobile-drawer .md-nav{\n  display:flex;\n  flex-direction:column;\n}\n.mobile-drawer .md-item{\n  border-bottom:1px solid rgba(33,29,24,0.08);\n}\n.mobile-drawer .md-item summary{\n  list-style:none;\n  padding:16px 2px;\n  display:flex;\n  justify-content:space-between;\n  align-items:center;\n  font-size:15px;\n  font-weight:500;\n  cursor:pointer;\n  gap:12px;\n}\n.mobile-drawer .md-item summary::-webkit-details-marker{display:none;}\n.mobile-drawer .md-item summary::after{\n  content:'+';\n  font-weight:400;\n  color:var(--ink-soft,#5C5548);\n  flex-shrink:0;\n}\n.mobile-drawer .md-item[open] summary::after{content:'–';}\n.mobile-drawer .md-item ul{\n  padding:0 2px 14px;\n  margin:0;\n  list-style:none;\n}\n.mobile-drawer .md-item ul li{padding:7px 0;font-size:14px;}\n.mobile-drawer .md-item ul li a{color:var(--ink-soft,#5C5548);}\n.mobile-drawer .md-shop-all{color:var(--gold-deep,#B98A4E)!important;font-weight:600;}\n.mobile-drawer .md-link{\n  display:block;\n  padding:16px 2px;\n  border-bottom:1px solid rgba(33,29,24,0.08);\n  font-size:15px;\n  font-weight:500;\n  color:var(--ink,#211D18);\n  text-decoration:none;\n}\n.mobile-drawer .md-link--accent{color:var(--gold-deep,#B98A4E);}\n\n@media(min-width:1281px){\n  .mobile-drawer{display:none !important;}\n}\n@media(max-width:560px){\n  .mobile-drawer{padding:10px !important;}\n  .mobile-drawer .md-sheet{\n    width:min(100%, 92vw);\n    border-radius:16px;\n    padding:18px 16px 40px;\n  }\n}\n\n\n/* NAV_SHEET_COMPAT_730 */\n.mobile-drawer .logo{position:static !important;display:inline-flex !important;align-items:center;}\n.mobile-drawer .logo img{display:block;max-width:150px !important;height:auto !important;}\n.mobile-drawer .md-head{position:sticky;top:0;z-index:3;background:var(--ivory,#FAF7F0);}\n\n/* Support both old JS (no .open class) and new JS */\n.mobile-drawer.open,\n.mobile-drawer:not([hidden]){\n  opacity:1 !important;\n  visibility:visible !important;\n  pointer-events:auto !important;\n}\n.mobile-drawer.open .md-sheet,\n.mobile-drawer:not([hidden]) .md-sheet{\n  transform:translate3d(0,0,0) !important;\n}\n\n/* Fallback when cached HTML has no .md-sheet wrapper */\n.mobile-drawer > .md-head,\n.mobile-drawer > .md-nav{\n  width:min(400px,86vw);\n  margin-left:auto;\n  background:var(--ivory,#FAF7F0);\n  box-sizing:border-box;\n}\n.mobile-drawer > .md-head{\n  border-radius:18px 18px 0 0;\n  padding:20px 18px 12px;\n  box-shadow:0 24px 80px -20px rgba(15,12,8,0.55),0 0 0 1px rgba(33,29,24,0.06);\n}\n.mobile-drawer > .md-nav{\n  border-radius:0 0 18px 18px;\n  padding:0 18px 24px;\n  box-shadow:0 24px 80px -20px rgba(15,12,8,0.55),0 0 0 1px rgba(33,29,24,0.06);\n  max-height:calc(100vh - 96px);\n  overflow:auto;\n}\n";
  function apply(){
    var id='oxiram-nav-sheet-compat-730';
    var n=document.getElementById(id);
    if(!n){
      n=document.createElement('style');
      n.id=id;
      n.textContent=css;
      (document.head||document.documentElement).appendChild(n);
    }
    var drawer=document.querySelector('[data-oxiram-drawer]');
    if(drawer && !drawer.querySelector('.md-sheet')){
      var sheet=document.createElement('div');
      sheet.className='md-sheet';
      while(drawer.firstChild) sheet.appendChild(drawer.firstChild);
      drawer.appendChild(sheet);
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  document.addEventListener('shopify:section:load', apply);
})();


/* NAV_VISIBILITY_FIX_731 */
(function(){
  if(typeof document==='undefined') return;
  var css='\n/* NAV_VISIBILITY_FIX_731 */\n.mobile-drawer{\n  position:fixed !important;\n  inset:0 !important;\n  z-index:2147483000 !important;\n  display:flex !important;\n  justify-content:flex-end !important;\n  padding:12px !important;\n  background:rgba(18,16,12,.46) !important;\n  -webkit-backdrop-filter:blur(8px);\n  backdrop-filter:blur(8px);\n  overflow:hidden !important;\n}\n.mobile-drawer .logo{position:static !important;display:inline-flex !important;align-items:center;}\n.mobile-drawer .logo img{max-width:150px !important;height:auto !important;display:block;}\n.mobile-drawer .md-sheet,\n.mobile-drawer > .md-head,\n.mobile-drawer > .md-nav{\n  width:min(410px,86vw) !important;\n  margin-left:auto !important;\n  background:#faf7f0 !important;\n  color:#211d18 !important;\n  box-sizing:border-box !important;\n}\n.mobile-drawer .md-sheet{\n  border-radius:18px !important;\n  box-shadow:0 24px 80px -20px rgba(15,12,8,.55),0 0 0 1px rgba(33,29,24,.06) !important;\n  height:100% !important;\n  overflow:auto !important;\n  padding:20px 18px 42px !important;\n  transform:none !important;\n}\n.mobile-drawer > .md-head{border-radius:18px 18px 0 0 !important;padding:20px 18px 10px !important;}\n.mobile-drawer > .md-nav{border-radius:0 0 18px 18px !important;padding:0 18px 24px !important;max-height:calc(100vh - 96px) !important;overflow:auto !important;}\n.mobile-drawer .md-head{display:flex !important;justify-content:space-between !important;align-items:center !important;position:sticky !important;top:0 !important;background:#faf7f0 !important;border-bottom:1px solid rgba(33,29,24,.08) !important;z-index:3 !important;}\n.mobile-drawer .md-close{width:40px !important;height:40px !important;border-radius:999px !important;border:1px solid rgba(33,29,24,.16) !important;background:#fff !important;color:#211d18 !important;}\n.mobile-drawer .md-item summary,.mobile-drawer .md-link{color:#211d18 !important;}\n.mobile-drawer .md-item ul li a{color:#5c5548 !important;}\n.mobile-drawer .md-shop-all{color:#b98a4e !important;}\n';
  function apply(){
    var id='oxiram-nav-visibility-fix-731';
    var s=document.getElementById(id);
    if(!s){
      s=document.createElement('style');
      s.id=id;
      s.textContent=css;
      (document.head||document.documentElement).appendChild(s);
    }
    var drawer=document.querySelector('[data-oxiram-drawer]');
    if(drawer && !drawer.querySelector('.md-sheet')){
      var sheet=document.createElement('div');
      sheet.className='md-sheet';
      while(drawer.firstChild) sheet.appendChild(drawer.firstChild);
      drawer.appendChild(sheet);
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  document.addEventListener('shopify:section:load', apply);
})();
